/**
 * @generated SignedSource<<e0d3fe90baaea4232eae12b147dd0ed3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoutineEditChecklistTaskQuery$variables = {
  id: string;
  include: boolean;
  includeWorkspace: boolean;
  workspaceId: string;
};
export type RoutineEditChecklistTaskQuery$data = {
  readonly routine?: {
    readonly activeVersion: {
      readonly tasks: ReadonlyArray<{
        readonly id: string;
      }>;
    };
    readonly id: string;
    readonly isOrg: boolean;
  } | null;
  readonly workspace?: {
    readonly topics: ReadonlyArray<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"TaskScreenComponent_topics">;
    }> | null;
  };
};
export type RoutineEditChecklistTaskQuery = {
  response: RoutineEditChecklistTaskQuery$data;
  variables: RoutineEditChecklistTaskQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "include"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeWorkspace"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "workspaceId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isOrg",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RoutineEditChecklistTaskQuery",
    "selections": [
      {
        "condition": "includeWorkspace",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "Workspace",
            "kind": "LinkedField",
            "name": "workspace",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "OrgTopic",
                "kind": "LinkedField",
                "name": "topics",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TaskScreenComponent_topics"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "condition": "include",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "Routine",
            "kind": "LinkedField",
            "name": "routine",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RoutineVersion",
                "kind": "LinkedField",
                "name": "activeVersion",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "tasks",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "RoutineEditChecklistTaskQuery",
    "selections": [
      {
        "condition": "includeWorkspace",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "Workspace",
            "kind": "LinkedField",
            "name": "workspace",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "OrgTopic",
                "kind": "LinkedField",
                "name": "topics",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isPrivate",
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ]
      },
      {
        "condition": "include",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "Routine",
            "kind": "LinkedField",
            "name": "routine",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RoutineVersion",
                "kind": "LinkedField",
                "name": "activeVersion",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "tasks",
                    "plural": true,
                    "selections": [
                      (v8/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "b360f4642ef8e0028f7d9bc92ce743bd",
    "id": null,
    "metadata": {},
    "name": "RoutineEditChecklistTaskQuery",
    "operationKind": "query",
    "text": "query RoutineEditChecklistTaskQuery(\n  $id: ID!\n  $workspaceId: ID!\n  $include: Boolean!\n  $includeWorkspace: Boolean!\n) {\n  workspace(id: $workspaceId) @include(if: $includeWorkspace) {\n    topics {\n      id\n      ...TaskScreenComponent_topics\n    }\n    id\n  }\n  routine(id: $id) @include(if: $include) {\n    id\n    isOrg\n    activeVersion {\n      tasks {\n        __typename\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment RoutineEditMainOrgTopicListItemSelector_topics on OrgTopic {\n  id\n  name\n  description\n}\n\nfragment RoutineEditMainOrgTopicListItem_topics on OrgTopic {\n  __typename\n  ...RoutineEditMainOrgTopicListItemSelector_topics\n}\n\nfragment TaskConnections_topics on OrgTopic {\n  id\n  name\n  isPrivate\n  ...RoutineEditMainOrgTopicListItemSelector_topics\n}\n\nfragment TaskScreenComponent_topics on OrgTopic {\n  id\n  name\n  isPrivate\n  ...RoutineEditMainOrgTopicListItem_topics\n  ...TaskConnections_topics\n}\n"
  }
};
})();

(node as any).hash = "e5709455616f5499abe2ea2c5d41318e";

export default node;
